import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Avatar,
  Box,
  InputLabel,
  Select,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { GlobalStyles } from "@mui/system";
import { IconButton } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";
import { useLocation } from "react-router-dom";
import { toast,ToastContainer  } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { useParams } from "react-router-dom";
// import StudentPaymentList from "./StudentPaymentsList";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
function PrincipalEditFeeTransactionList() {
  const { oId,board } = useAuth();
   const location = useLocation();
       const { CategoryType } = location.state || {};
       const Type =CategoryType?.categoryType;
       const student = JSON.parse(sessionStorage.getItem("paymentListStudent"));

     const navigate = useNavigate();
   const { admissionNumber,rolePayment } = useParams();
  const [loading, setLoading] = useState(true);
   const [patchloading, setPatchLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [transactionData, setTransactionData] = useState([]);

   const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState({});

  // open dialog with row data
  const handleEditClick = (row) => {
    setEditData({ ...row });
    setOpen(true);
  };

  // handle field change
  const handleChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  // call PATCH API
const handleSave = async () => {

   //validation before submitting
  if (!editData.paymentAmount || editData.paymentAmount === 0) {
    toast.error("Payment amount must be greater than zero", {
      position: "top-right",
      autoClose: 2000,
    });
    return; 
  }

  setPatchLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/transaction/updateTransactions/${editData.trsnId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editData),
      }
    );

    if (!response.ok) {
      // ✅ Try to parse backend error message
      const errorText = await response.text();
      throw new Error(errorText || "Failed to update record");
    }

    toast.success("✅ Record updated successfully!", {
      position: "top-right",
      autoClose: 1000,
    });

    setOpen(false);
    fetchDialogTableData(); // refresh table
  } catch (error) {
    console.error("Error updating record:", error);

    toast.error(`${error.message}`, {
      position: "top-right",
      autoClose: 2000,
    });
  } finally {
    setPatchLoading(false);
  }
};



  // useEffect(() => {
  //   const fetchDialogTableData = async () => {
  //     if (!admissionNumber || !rolePayment) return; // Prevent API call if no admission number is selected

  //     setLoading(true);
  //     try {
  //       const response = await fetch( `${baseUrl}/api/transaction/getAllTransaction/${admissionNumber}/${oId}/${rolePayment}`
  //       );
  //       if (!response.ok) {
  //         throw new Error("Failed to fetch data");
  //       }

  //       const data = await response.json();
  //       console.log("Fetched Data:", data);
  //       setTransactionData(data || []); // Ensure it's always an array
  //     } catch (error) {
  //       console.error("Error fetching Bus Numbers:", error);
  //       setTransactionData([]); // Ensure state remains consistent
  //     } finally {
  //       setLoading(false); // Set loading to false after fetching
  //     }
  //   };

  //   fetchDialogTableData();
  // }, [admissionNumber,rolePayment, oId]); // Re-fetch when `selectedadmissionNo` or `oId` changes


  const fetchDialogTableData = async () => {
    if (!admissionNumber || !rolePayment) return;

    setLoading(true);
    try {
      let response;

      if (rolePayment === "additional_fee") {
        response = await fetch(
          `${baseUrl}/api/studentSoldItems/getInvoiceSummaryByStudentId/${student.studentId}`
        );
      } else {
        response = await fetch(
          `${baseUrl}/api/transaction/getAllTransaction/${admissionNumber}/${oId}/${rolePayment}`
        );
      }

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      console.log("Fetched Data:", data);
      setTransactionData(data || []); // Always set an array
    } catch (error) {
      console.error("Error fetching dialog table data:", error);
      setTransactionData([]); // Prevent stale data
    } finally {
      setLoading(false);
    }
  };
useEffect(() => {
  fetchDialogTableData();
}, [admissionNumber, rolePayment, oId]);


  const roleLabels = {
  admission_fee: "Admission Fee",
  bus_fee: "Bus Fee",
  tution_fee: "Tuition Fee",
  other_fee: "Miscellaneous  Fee",
  exam_fee: "Exam Fee",
  hostel_fee: "Hostel Fee",
  additional_fee: "Additional Fee",
};

const readableLabel = roleLabels[rolePayment] || "Fee";


const cellStyle = {
  borderRight: "1px solid #ddd",
  padding: "2px",
  textAlign: "center",
  backgroundColor: "#fff9c4",
  fontWeight: "bold",
  fontSize: "14px",
};

const tabcellStyle = {
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                    
};

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
    <Card
      style={{
        // margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        // maxHeight: "100vh",
        // overflow: "hidden",
        width: "100%",
      }}
    >
      <CardContent>
         
        <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
          <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
    {`${readableLabel} Transaction List`}
  </Typography>
        </Box>

   

        <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px", // For WebKit-based browsers
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Track color
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey", // Thumb color
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />

        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "800px",
            overflow: "auto",
            //  maxHeight: "800px",
            //   overflow: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>
    
          <TableCell sx={cellStyle}>Payment Date</TableCell>
          <TableCell sx={cellStyle}>Amount Paid</TableCell>
          <TableCell sx={cellStyle}>Transaction Id</TableCell>
          <TableCell sx={cellStyle}>Payment Type</TableCell>
          <TableCell sx={cellStyle}>Action</TableCell>
    

              </TableRow>
            </TableHead>

            <TableBody>
              {/* {!hasFetchedOnce || loading ? ( */}
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={12}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                    >
                      <CircularProgress />
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        Loading Data...
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : transactionData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                transactionData.map((row, index) => (
                  <TableRow
                    key={row.id}
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s",
                      height: "30px", // Reduced row height
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white"; // Default color
                    }}
                  >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {index + 1}
                    </TableCell>

   
          <TableCell sx={tabcellStyle}>{row.paymentDate}</TableCell>
            <TableCell sx={tabcellStyle}>{row.paymentAmount}</TableCell>
            <TableCell sx={tabcellStyle}>{row.transactionId || "N/A"}</TableCell>
            <TableCell sx={tabcellStyle}>{row.payMethod}</TableCell>
          <TableCell
          sx={{
            borderLeft: "1px solid #ddd",
            padding: "4px",
            textAlign: "center",
          }}
        >
          <Button
            type="button"
            onClick={() => handleEditClick(row)}   // ✅ correct
            sx={{
              backgroundColor: "#1976d2",
              color: "white",
              fontWeight: "bold",
              fontSize: "0.6rem",
              height: "25px",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
          >
            Edit
          </Button>
        </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
  {/* Edit Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Edit Transactions</DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Payment Date"
            type="date"
            fullWidth
            margin="dense"
            value={editData.paymentDate || ""}
            onChange={(e) => handleChange("paymentDate", e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          
          <TextField
            label="Pay Method"
            fullWidth
            margin="dense"
            value={editData.payMethod || ""}
            onChange={(e) => handleChange("payMethod", e.target.value)}
          />
          <TextField
            label="Transaction ID"
            fullWidth
            margin="dense"
            value={editData.transactionId || ""}
            onChange={(e) => handleChange("transactionId", e.target.value)}
          />
        <TextField
  label="Payment Amount"
  type="text"
  fullWidth
  margin="dense"
  value={editData.paymentAmount || ""}
  inputProps={{
    min: 0, // ✅ Prevents negative input
  }}
  error={editData.paymentAmount === 0} // ✅ Shows red border if 0
  helperText={
    editData.paymentAmount === 0 ? "Amount should be more than zero" : ""
  } // ✅ Error message
  onChange={(e) => {
    const value = e.target.value;

    // ✅ Allow empty string for clearing
    if (value === "") {
      handleChange("paymentAmount", "");
      return;
    }

    // ✅ Parse as number
    const numberValue = Number(value);

    // ✅ Prevent negative input
    if (numberValue < 0) return;

    // ✅ Update only if valid
    handleChange("paymentAmount", numberValue);
  }}
/>


        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} variant="outlined">
            Cancel
          </Button>
          {/* <Button onClick={handleSave} color="primary" variant="contained">
            Save
          </Button> */}
           <Button
                        onClick={handleSave}
                        color="success"
                        variant="outlined"
                        sx={{
                          backgroundColor: "#3C3972",
                          color: "white",
                          fontSize: "0.8rem",
                          height: "35px",
                          minWidth: "80px", // Ensures consistent button size
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          "&:hover": {
                            backgroundColor: "#3C3972",
                          },
                        }}
                        disabled={patchloading} // Disable button while loading
                      >
                        {patchloading ? (
                          <CircularProgress size={20} sx={{ color: "white" }} />
                        ) : (
                          "Save"
                        )}
                      </Button>
        </DialogActions>
      </Dialog>
<ToastContainer position="top-right" autoClose={2000} />
      </CardContent>
    </Card>
    </Box>
  );
}

export default PrincipalEditFeeTransactionList;